import { set } from "date-fns";
import { React, useState, useRef, useEffect } from "react";
import BetLockMatchOddsModal from "./betlock-matchs-odd-modal";
import FullBetListModal from "./FullBetListModal.js";
import FullBetListSettingModal from "./FullBetListSettingModal.js";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";
import { useDispatch, useSelector } from "react-redux";
const MarketAnalysisRight = ({ eventDetails, betsData }) => {
  const [open, setOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [matchOddsUsers, setMatchOddsUsers] = useState([]);
  const [betLockButtonText, setbetLockButtonText] = useState("Bet Lock");
  const dropdownRef = useRef(null);
  const [fullBetList, setFullBetList] = useState(true);
  const [showSettingsModal, setShowSettingsModal] = useState(false);

  const response = useSelector((state) => state.userStore);

  const userRole = response.data?.user_role ?? "";

  const [showTv, setShowTv] = useState(false);
  const [showScore, setShowScore] = useState(false);

  const getBetMasterName = (bet) => {
    if (bet?.master) return bet.master;
    const shares = bet?.master_sharing || [];
    if (!shares.length) return "";
    const direct = [...shares].sort(
      (a, b) => (b.user_role || 0) - (a.user_role || 0)
    )[0];
    return direct?.uname || "";
  };
  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const { marketId } = useParams();
  const [betLockMarketType, setBetLockMarketType] = useState("");

  const openBetLockMatchOdd = async () => {
    console.log("Match Odds clicked");
    setbetLockButtonText("Match Odds");
    setOpen(false);
    setBetLockMarketType("Match Odds");

    const response = await axiosInstance.get(
      "/user/get-all-users/match-odds/" + marketId
    );
    setMatchOddsUsers(response.data);
    setShowModal(true);
    // open modal or perform action
  };

  const openBetLockOtherMarket = async () => {
    console.log("Other Markets clicked");
    setbetLockButtonText("Other Markets");
    setOpen(false);
    setBetLockMarketType("Other Markets");

    const response = await axiosInstance.get(
      "/user/get-all-users/other-markets/" + marketId
    );
    setMatchOddsUsers(response.data);
    setShowModal(true);
  };

  const [showFullBetModal, setShowFullBetModal] = useState(false);

  const handleFullBetList = () => {
    setShowFullBetModal(true);
  };


  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <div className="market-right" style={{ marginTop: "10px" }}>
      {/* Scoped CSS */}
      <style>
        {`
          /* Hover background */
          .market-right .dropdown-menu .dropdown-item:hover,
          .market-right .dropdown-menu .dropdown-item:focus {
            background-color: #f1f3f5;
          }

          .market-right .dropdown-menu {
            border: none;
          }

          /* Remove bootstrap caret */
          .market-right .dropdown-toggle::after {
            display: none;
          }

          /* Custom arrow */
          .market-right .arrow {
            margin-left: 6px;
            display: inline-block;
            transition: transform 0.2s ease;
            font-size: 10px;
          }

          .market-right .arrow.open {
            transform: rotate(180deg);
          }
        `}
      </style>
      <div className="card card-accent-success right-content">
        <div className="card-body pt-1 pb-1">
          <div className="d-flex">
            <div className="input-prepend input-append">
              <div className="btn-group position-relative" ref={dropdownRef}>
                <button
                  type="button"
                  className="btn btn-success dropdown-toggle d-flex align-items-center site_family"
                  style={{ background: "#04b181" }}
                  onClick={() => setOpen(!open)}
                >
                  {betLockButtonText}
                  <span className={`arrow ${open ? "open" : ""}`}>▼</span>
                </button>

                {open && (
                  <div className="dropdown-menu show">
                    <button
                      className="dropdown-item site_family"
                      type="button"
                      onClick={openBetLockMatchOdd}
                    >
                      Match Odds
                    </button>

                    <button
                      className="dropdown-item site_family"
                      type="button"
                      onClick={openBetLockOtherMarket}
                    >
                      Other Markets
                    </button>
                  </div>
                )}
              </div>
            </div>
            {eventDetails?.game_type == 4 || eventDetails?.game_type == 5 ? (
              <button
                type="button"
                className="btn btn-success site_family"
                style={{ background: "#04b181", marginLeft: "5px" }}
                onClick={() => {
                  const width = 1200;
                  const height = 560;
                  const left = window.screenX + (window.outerWidth - width) / 2;
                  const top =
                    window.screenY + (window.outerHeight - height) / 2;

                  window.open(
                    `/agent/hr-gr-user-book/${marketId}`,
                    "UserBookWindow",
                    `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
                  );
                }}
              >
                User Book
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-success site_family"
                style={{ background: "#04b181", marginLeft: "5px" }}
                onClick={() => {
                  const width = 1200;
                  const height = 560;
                  const left = window.screenX + (window.outerWidth - width) / 2;
                  const top =
                    window.screenY + (window.outerHeight - height) / 2;

                  window.open(
                    `/agent/user-book/${marketId}/1`,
                    "UserBookWindow",
                    `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
                  );
                }}
              >
                User Book
              </button>
            )}
          </div>
        </div>
      </div>

      <div>
        <div
          className="right-content-wrapper"
          style={{ background: "transparent" }}
        >
          <div className="tv-section-wrapper" style={{ float: "unset" }}>
            <ul
              className="nav nav-tabs"
              role="tablist"
              style={{ background: "#ffffff", float: "unset" }}
            >
              <li
                className="nav-item tvClose"
                style={{
                  marginBottom: "4px",
                  marginLeft: "3px",

                  width:
                    eventDetails?.game_type == 4 || eventDetails?.game_type == 5
                      ? "100%"
                      : ""
                }}
              >
                <a
                  className="nav-link  btn btn-primary btn-xs col site_family"
                  data-toggle="tab"
                  href="#tv-section-1"
                  role="tab"
                  style={{
                    borderRadius: "5px 0 0 5px",
                    padding: "8px 0px 0px 0px"
                  }}
                  onClick={() => {
                    setShowTv(true);
                    setShowScore(false);
                  }}
                >
                  Tv
                </a>
              </li>
              <li
                className="nav-item scoreOpen"
                style={{
                  marginLeft: "2px",
                  display:
                    eventDetails?.game_type == 4 || eventDetails?.game_type == 5
                      ? "none"
                      : ""
                }}
              >
                <a
                  className="nav-link  btn btn-primary btn-xs col site_family"
                  data-toggle="tab"
                  href="#tv-section-2"
                  role="tab"
                  style={{
                    borderRadius: "0 5px 5px 0px",
                    padding: "8px 0px 0px 0px"
                  }}
                  onClick={() => {
                    setShowTv(false);
                    setShowScore(true);
                  }}
                >
                  Score Card
                </a>
              </li>
            </ul>
            <div className="tab-content">
              <div
                className={showTv ? "tab-pane active" : "tab-pane"}
                id="tv-section-1"
                role="tabpanel"
                style={{ padding: "5px", marginTop: "0px" }}
              >
                <iframe
                  width="100%"
                  src={`https://e765432.diamondcricketid.com/dtv.php?id=${eventDetails.evt_id}`}
                  height="300"
                  title="Online Sport Live Score"
                  scrolling="auto"
                  marginWidth="0"
                  marginHeight="0"
                  frameBorder="0"
                  allowFullScreen="allowfullscreen"
                  className="live-score-iframe"
                  style={{ backgroundColor: "rgb(16, 16, 16)" }}
                  id="scoreFrame"
                  data-ruffle-polyfilled=""
                ></iframe>
              </div>
              <div
                className={showScore ? "tab-pane active" : "tab-pane"}
                id="tv-section-2"
                role="tabpanel"
                style={{ padding: "5px", marginTop: "14px" }}
              >
                <div className="tv-section-wrapper">Score Card</div>
              </div>
            </div>
          </div>

          <div style={{ marginTop: "20px" }}>
            <div>
              <div
                className="card-header"
                style={{
                  textAlign: "left",
                  borderTop: "2px solid #20a8d8",
                  borderRadius: "5px 5px 0px 0px"
                }}
              >
                <strong className="site_family">Open Bets (0) &nbsp; </strong>
              </div>
            </div>
            <div style={{ borderRadius: "15px" }}>
              <table
                width="100%"
                className="table-responsive table01"
                style={{
                  fontSize: "14px",
                  borderRadius: "0px 0px 5px 5px",
                  borderBottom: "solid 1px #c7cdd4"
                }}
              >
                <tbody style={{ fontSize: "15px", background: "#ffffff" }}>
                  <tr
                    style={{
                      lineHeight: "20px",
                      background: "#fff!important",
                      color: "#000",
                      fontWeight: "600"
                    }}
                  >
                    <th
                      width="30%"
                      className="site_family"
                      style={{ textAlign: "left", padding: "6px" }}
                    >
                      Runner
                    </th>
                    <th
                      width="10%"
                      className="site_family"
                      style={{ textAlign: "left" }}
                    >
                      Price
                    </th>
                    <th
                      width="10%"
                      className="site_family"
                      style={{ textAlign: "left" }}
                    >
                      Size
                    </th>
                    <th
                      width="10%"
                      className="site_family"
                      style={{ textAlign: "left" }}
                    >
                      Better
                    </th>
                    <th
                      width="10%"
                      className="site_family"
                      style={{ textAlign: "left" }}
                    >
                      Master
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="bets-section-wrapper" style={{ marginTop: "15px" }}>
            <div
              aria-expanded="true"
              style={{ marginTop: "10px !important" }}
              className="v-expansion-panel mt-1 mb-5 p-0 v-expansion-panel--active v-expansion-panel--next-active v-item--active"
            >
              <div className="v-expansion-panel-content black--text pa-0">
                <div className="v-expansion-panel-content__wrap">
                  <div className="">
                    <div>
                      <div>
                        <div
                          className="pa-5 text-center"
                          style={{ background: "white" }}
                        >
                          <div
                            className="card-header"
                            style={{
                              textAlign: "left",
                              borderTop: "2px solid #20a8d8"
                            }}
                          >
                            <strong className="site_family">
                              Matched Bets(
                              <span id="bet_cnt">
                                {betsData ? betsData.length : 0}
                              </span>
                              ) &nbsp;{" "}
                            </strong>
                            <button
                              className="btn btn-sm btn-primary site_family"
                              onClick={handleFullBetList}
                            >
                              Full Bet List
                            </button>

                            <button
                              style={{
                                display:
                                  userRole == 1 ||
                                  userRole == 2 ||
                                  userRole == 3
                                    ? ""
                                    : "none"
                              }}
                              className="btn btn-sm btn-secondary ml-2 site_family"
                              onClick={() => setShowSettingsModal(true)}
                            >
                              <i className="fas fa-cog me-1"></i> Settings-
                            </button>
                          </div>
                          <div>
                            <table
                              className="table-responsive table01 table01_matched"
                              style={{ margin: "4px" }}
                            >
                              <tbody style={{ backgroundColor: "#fff" }}>
                                <tr>
                                  <td
                                    colspan="5"
                                    className="align-left"
                                    style={{
                                      fontSize: "1rem",
                                      color: "#243a48",
                                      textAlign: "center"
                                    }}
                                  ></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <table
                            width="100%"
                            className="table-responsive table01"
                            style={{
                              fontSize: "14px"
                            }}
                          >
                            <tbody style={{ fontSize: "15px" }}>
                              <tr
                                style={{
                                  lineHeight: "20px",
                                  background: "#fff!important",
                                  color: "#000",
                                  fontWeight: "600"
                                }}
                              >
                                <th
                                  width="30%"
                                  className="site_family"
                                  style={{ textAlign: "left" }}
                                >
                                  Runner
                                </th>
                                <th
                                  width="10%"
                                  className="site_family"
                                  style={{ textAlign: "left" }}
                                >
                                  Price
                                </th>
                                <th
                                  width="10%"
                                  className="site_family"
                                  style={{ textAlign: "left" }}
                                >
                                  Size
                                </th>
                                <th
                                  width="10%"
                                  className="site_family"
                                  style={{ textAlign: "left" }}
                                >
                                  Better
                                </th>
                                <th
                                  width="10%"
                                  className="site_family"
                                  style={{ textAlign: "left" }}
                                >
                                  Master
                                </th>
                              </tr>
                              {betsData && betsData.length > 0 ? (
                                betsData.map((bet, index) => (
                                  <tr
                                    key={index}
                                    style={{
                                      lineHeight: "18px",
                                      height: "28px",
                                      width: "100%",
                                      borderBottom:
                                        "0px solid rgb(186, 186, 186)",
                                      color: "#000",
                                      background:
                                        bet.type &&
                                        (bet.type.toLowerCase() === "l" ||
                                          bet.type.toLowerCase() === "n")
                                          ? "#ffcccb"
                                          : "#e3f9ff"
                                    }}
                                    className="bgyellow2"
                                    title={bet.section}
                                  >
                                    <td
                                      style={{
                                        textAlign: "left",
                                        padding: "8px"
                                      }}
                                    >
                                      <div
                                        style={{
                                          overflow: "hidden",
                                          whiteSpace: "nowrap"
                                        }}
                                        className="site_family"
                                      >
                                        {bet.section}
                                      </div>
                                    </td>

                                    <td
                                      style={{
                                        textAlign: "left"
                                      }}
                                      className="site_family"
                                    >
                                      {bet.rate}
                                    </td>

                                    <td
                                      style={{
                                        textAlign: "left"
                                      }}
                                      className="site_family"
                                    >
                                      {formatTruncate(bet.amnt)}
                                    </td>

                                    <td
                                      style={{
                                        textAlign: "left"
                                      }}
                                      className="site_family"
                                    >
                                      {bet.uname}
                                    </td>

                                    <td
                                      style={{
                                        textAlign: "left"
                                      }}
                                      className="site_family"
                                    >
                                      {getBetMasterName(bet)}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="5"
                                    style={{
                                      textAlign: "center",
                                      padding: "10px"
                                    }}
                                  >
                                    No Records Found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                          <div>
                            <table className="table-responsive table01 table01_matched">
                              <tbody
                                style={{ backgroundColor: "#fff" }}
                              ></tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <BetLockMatchOddsModal
        matchOddsUsers={matchOddsUsers}
        betLockMarketType={betLockMarketType}
        show={showModal}
        onClose={() => setShowModal(false)}
      />
      <FullBetListModal
        show={showFullBetModal}
        onClose={() => setShowFullBetModal(false)}
        matchedBets={betsData} // your existing matched bets
        unmatchedBets={[]} // pass unmatched array when ready
      />
      <FullBetListSettingModal
        show={showSettingsModal}
        onClose={() => setShowSettingsModal(false)}
      />
    </div>
  );
};

export default MarketAnalysisRight;
